import { getGroupChipColor } from '../../utils/groupColors';

/**
 * GroupChip — the one chip treatment for a connection's groups.
 *
 * The People card and the detail pages drew their own chips at different sizes
 * (2px/10px/13px vs 4px/12px/14px), so the same person's chips didn't match
 * across the two surfaces — the group-chip drift item in people-epic. Both
 * render this now. Colours still come from utils/groupColors.
 *
 * @param {object} group - the group ({ id, name, ... })
 * @param {function} onClick - optional; makes the chip tappable
 * @param {object} style - optional overrides
 */
export const GroupChip = ({ group, onClick, style }) => {
  const colors = getGroupChipColor(group);
  return (
    <span
      onClick={onClick}
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '12px',
        backgroundColor: colors.bg,
        color: colors.text,
        fontSize: '13px',
        fontWeight: '400',
        lineHeight: '1.4',
        whiteSpace: 'nowrap',
        ...(onClick ? { cursor: 'pointer' } : {}),
        ...style,
      }}
    >
      {group.name}
    </span>
  );
};

/**
 * GroupOverflowChip — the "+N" chip for a capped list. Same geometry, neutral fill.
 */
export const GroupOverflowChip = ({ count, style }) => (
  <span
    style={{
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: '12px',
      backgroundColor: '#EDEDF0',
      color: '#8E8E93',
      fontSize: '13px',
      fontWeight: '400',
      lineHeight: '1.4',
      ...style,
    }}
  >
    +{count}
  </span>
);

export default GroupChip;
